// Credentials never enter Vuex, browser storage or application settings.
const session = {
  epoch: 0,
  validationEpoch: 0,
  token: null,
  credentials: null,
  onClear: null,
  expiresAt (token) {
    try {
      const parts = String(token || '').split('.')
      if (parts.length !== 3) return 0
      const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
      const exp = JSON.parse(atob(payload)).exp
      return typeof exp === 'number' && Number.isFinite(exp) && exp > 0 ? exp * 1000 : 0
    } catch (error) {
      return 0
    }
  },
  isValid (token) {
    // Local expiry is only a fail-closed guard, never a substitute for server validation.
    return this.expiresAt(token) > Date.now()
  },
  clear () {
    this.epoch += 1
    this.validationEpoch += 1
    this.token = null
    this.credentials = null
    if (this.onClear) this.onClear()
  },
  install (credentials, token, epoch) {
    if (epoch !== this.epoch || !this.isValid(token) || !credentials ||
      typeof credentials.username !== 'string' || !credentials.username ||
      typeof credentials.password !== 'string' || !credentials.password) return false
    this.token = token
    this.credentials = { username: credentials.username, password: credentials.password }
    return true
  }
}
export default session
